import React, { Component } from 'react';
import { FormControl } from 'react-bootstrap';
import * as PropTypes from 'prop-types';

import './ScientificNotationInput.sass';

export default class ScientificNotationInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };
  }

  componentDidMount() {
    if (this.state.value) {
      this.updateFormatting();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let nextValue = nextProps.value;
    const asFloat = Number.parseFloat(nextValue);
    const numDigits = asFloat.toString().length;
    if (numDigits >= this.props.convertAt) {
      nextValue = asFloat.toExponential(this.props.precision);
    }
    this.setState({
      value: nextValue,
    });
  }

  updateInput = (event) => {
    this.setState({
      value: event.target.value,
    });
  };

  updateFormatting = (triggerOnChange = false) => {
    let nextValue = this.state.value;
    const currentValue = this.state.value;
    const asFloat = Number.parseFloat(this.state.value);
    const numDigits = asFloat.toString().length;
    if (numDigits >= this.props.convertAt) {
      nextValue = asFloat.toExponential(this.props.precision);
    }
    const didChange = currentValue !== nextValue;
    if (didChange) {
      this.setState({
        value: nextValue,
      });
    }

    if (triggerOnChange && this.props.onChange) {
      this.props.onChange(asFloat);
    }
  };

  render() {
    let { precision, convertAt, onChange, ...rest } = this.props;

    let title = '',
      value = this.state.value;

    if (value !== undefined) {
      const valueAsString = value.toString();
      const asFloat = Number.parseFloat(this.state.value);
      const ePos = valueAsString.indexOf('e');

      if (ePos > -1) {
        const eIsNegative = valueAsString.charAt(ePos + 1) === '-';
        const minimumFractionDigits = Math.max(
          0,
          Math.min(eIsNegative ? valueAsString.substring(ePos + 2) : 0, 20)
        );
        title = asFloat.toLocaleString(undefined, { minimumFractionDigits });
      }
    } else {
      value = '';
    }

    return (
      <FormControl
        {...rest}
        type="number"
        title={title}
        value={value}
        onChange={this.updateInput}
        onBlur={this.updateFormatting}
        className="disable-stepper"
      />
    );
  }
}

ScientificNotationInput.propTypes = {
  precision: PropTypes.number,
  convertAt: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
};

ScientificNotationInput.defaultProps = {
  precision: 1,
  convertAt: 10,
};
